/** upstox-073 — the one fetch helper the Settings → Account page uses (credentials included). */
export const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export function apiFetch(path, opts = {}) {
  return fetch(`${API}${path}`, { credentials: 'include', ...opts });
}
